define("calendar/components/calendar/context-menu", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/object", "@ember/template", "shared/utils/constants/keys", "shared/utils/handle-key-down"], function (_exports, _component, _templateFactory, _component2, _tracking, _object, _template, _keys, _handleKeyDown) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _handleKeyPress, _handleLeftClick, _handleRightClick;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/object",0,"@ember/template",0,"shared/utils/constants/keys",0,"shared/utils/handle-key-down",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="o--dropWrapper cCA--dropDown eCA--dropDown {{unless @visible "u--hide"}}"
    style={{this.dynamicStyling}}
    {{did-insert this.addListeners}}
    {{did-update this.renderMenu @left @top}}
    {{will-destroy this.removeListeners}}
  >
    <div class="o--dropBody">
      <button
        {{on "click" @createNewCalendarNote}}
        class="o--btn o--btn--outline o--btn--block qa--calendar_right_click_menu"
        type="button"
      >
        {{svg-jar "notes" class="o--icon u--m__r__xs"}}
        {{t "calendar_notes.add_note"}}
      </button>
    </div>
  </div>
  
  */
  {
    "id": "obtgKpHL",
    "block": "[[[11,0],[16,0,[29,[\"o--dropWrapper cCA--dropDown eCA--dropDown \",[52,[51,[30,1]],\"u--hide\"]]]],[16,5,[30,0,[\"dynamicStyling\"]]],[4,[38,1],[[30,0,[\"addListeners\"]]],null],[4,[38,2],[[30,0,[\"renderMenu\"]],[30,2],[30,3]],null],[4,[38,3],[[30,0,[\"removeListeners\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n    \"],[11,\"button\"],[24,0,\"o--btn o--btn--outline o--btn--block qa--calendar_right_click_menu\"],[24,4,\"button\"],[4,[38,4],[\"click\",[30,4]],null],[12],[1,\"\\n      \"],[1,[28,[35,5],[\"notes\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n      \"],[1,[28,[35,6],[\"calendar_notes.add_note\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@visible\",\"@left\",\"@top\",\"@createNewCalendarNote\"],false,[\"unless\",\"did-insert\",\"did-update\",\"will-destroy\",\"on\",\"svg-jar\",\"t\"]]",
    "moduleName": "calendar/components/calendar/context-menu.hbs",
    "isStrictMode": false
  });

  let ContextMenuComponent = (_class = (_handleKeyPress = /*#__PURE__*/new WeakSet(), _handleLeftClick = /*#__PURE__*/new WeakSet(), _handleRightClick = /*#__PURE__*/new WeakSet(), class ContextMenuComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _handleRightClick);

      _classPrivateMethodInitSpec(this, _handleLeftClick);

      _classPrivateMethodInitSpec(this, _handleKeyPress);

      _initializerDefineProperty(this, "width", _descriptor, this);

      _initializerDefineProperty(this, "height", _descriptor2, this);

      _initializerDefineProperty(this, "menu", _descriptor3, this);
    }

    get dynamicStyling() {
      return (0, _template.htmlSafe)("left: ".concat(this.leftOffset, "; top: ").concat(this.topOffset, ";"));
    }

    get leftOffset() {
      const windowWidth = window.innerWidth;
      const left = Math.min(windowWidth - this.width, this.args.left);
      return left + 'px';
    }

    get topOffset() {
      const windowHeight = window.innerHeight;
      const top = Math.min(windowHeight - this.height, this.args.top);
      return top + 'px';
    }

    addListeners() {
      document.addEventListener('mousedown', _classPrivateMethodGet(this, _handleLeftClick, _handleLeftClick2).bind(this)); // Triggered when right clicking somewhere not producing custom context menu.

      document.addEventListener('contextmenu', _classPrivateMethodGet(this, _handleRightClick, _handleRightClick2).bind(this));
      document.addEventListener('keyup', _classPrivateMethodGet(this, _handleKeyPress, _handleKeyPress2).bind(this));
    }

    removeListeners() {
      document.removeEventListener('mousedown', _classPrivateMethodGet(this, _handleLeftClick, _handleLeftClick2));
      document.removeEventListener('contextmenu', _classPrivateMethodGet(this, _handleRightClick, _handleRightClick2));
      document.removeEventListener('keyup', _classPrivateMethodGet(this, _handleKeyPress, _handleKeyPress2));
    }

    renderMenu(menu) {
      this.menu = menu;
      this.width = menu === null || menu === void 0 ? void 0 : menu.offsetWidth;
      this.height = menu === null || menu === void 0 ? void 0 : menu.offsetHeight;
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "width", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "height", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "menu", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "addListeners", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addListeners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeListeners", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeListeners"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "renderMenu", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "renderMenu"), _class.prototype)), _class);
  _exports.default = ContextMenuComponent;

  function _handleKeyPress2(event) {
    (0, _handleKeyDown.default)(event, _keys.default.ESCAPE, () => {
      this.args.hideContextMenu();
    });
  }

  function _handleLeftClick2(event) {
    if (!this.menu) {
      return;
    }

    if (!this.menu.contains(event.target) && !this.isDestroyed && this.args.visible) {
      this.args.hideContextMenu();
    }
  }

  function _handleRightClick2(event) {
    const calendar = document.querySelector('#calendar');

    if (!calendar) {
      return;
    }

    if (!calendar.contains(event.target) && !this.isDestroyed) {
      this.args.hideContextMenu();
    }
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ContextMenuComponent);
});